import React, { useState, useEffect } from 'react';
import { FaBell } from 'react-icons/fa';
import axios from 'axios';
import './Notifications.css';
import config from '../../config';

const getNotificationDataUrl = `${config.BASE_URL}/notify-trucks`;

const Notifications = () => {
    const [notifyData, setNotifyData] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [newNotification, setNewNotification] = useState(false);

    const keyDisplayMap = {
        registration: "Registration",
        insurance: "Insurance",
        fitness: "Fitness",
        mv_tax: "MV Tax",
        puc: "PUC",
        ka_tax: "KA Tax",
        basic_and_KA_permit: "Basic & KA Permit",
    }

    const fetchNotifications = async () => {
        try {
            const response = await axios.get(getNotificationDataUrl,
                {
                    withCredentials: true,
                    headers: {
                        "Content-Type": "application/json",
                    }
                }
            );
            if (response.status === 200) {
                setNotifyData(response.data);
                console.log('Notifications fetched:', response.data);
            } else {
                console.error('Error fetching notifications:', response.data);
            }
        } catch (error) {
            console.error('Error fetching notifications:', error);
        }
    };

    // Function to schedule the fetching at 12:05 AM
    const scheduleFetchNotifications = () => {
        const now = new Date();
        let targetTime = new Date(now);
        targetTime.setHours(0, 5, 0, 0); // Set to 12:05 AM today or tomorrow

        if (targetTime <= now) {
            targetTime.setDate(now.getDate() + 1);
        }

        const timeUntilTarget = targetTime - now;

        setTimeout(() => {
            fetchNotifications(); // Fetch notifications once at 12:05 AM
            // After that, set an interval to fetch notifications every 24 hours
            setInterval(fetchNotifications, 24 * 60 * 60 * 1000); // 24 hours
        }, timeUntilTarget);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (showDropdown && !event.target.closest('.notification-dropdown') && !event.target.closest('.notification-button')) {
                setShowDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showDropdown]);

    useEffect(() => {
        // Initial fetch on component mount
        fetchNotifications();

        // Schedule the daily fetch at 12:05 AM
        scheduleFetchNotifications();
    }, []);

    const toggleDropdown = () => {
        if (showDropdown) {
            setShowDropdown(false);
        }
        else {
            setShowDropdown(true);
        }
        if (!showDropdown) {
            fetchNotifications(); // Fetch notifications only when opening
            setNewNotification(false);
        }
    };


    return (
        <div className="notifications">
            <button
                className={`notification-button ${newNotification ? 'new-notification' : ''}`} // Add class when new notification
                onClick={toggleDropdown}
            >
                <FaBell className="notification-icon" />
                {newNotification && <div className="new-notification-badge"></div>} {/* Badge for new notifications */}
            </button>
            {showDropdown && (
                <div className="notification-dropdown">
                    {notifyData.length > 0 ? (
                        notifyData.map((item, index) => {
                            let check = false
                            return (
                                <div
                                    key={index}
                                    className={`notification-card ${new Date(item.end_date) < new Date() ? (check = true && "highlight-yellow") : ""}`}
                                >
                                    <p><b>Truck No</b> {item.truck_no.split(' ').join('')}</p>
                                    <p>{keyDisplayMap[item.field_name] || item.field_name}</p>
                                    <p><b>Expires on</b> {new Date(item.end_date).toLocaleDateString()}</p>
                                    {check ? <span className="warning-icon">❗</span> : ""}
                                </div>
                            )
                        })
                    ) : (
                        <p>No notifications</p>
                    )}
                </div>
            )}
        </div>
    );
};

export default Notifications;